import { Injectable } from '@angular/core';

declare var $: any;
declare var bodymovin: any;

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  titulo: any;
  texto: any;
  imgTop: any;
  imgClass: any;
  animacion: any;
  current: any;
  stopAnimateRangeNum: boolean = false;

  constructor() { }

  close() {
    setTimeout( function() {
      $('#loading').modal('hide');
    }, 1000);
  }

  open(title:any, textHTML:any, imagen:any, imagenclass:any, animacion:any) {
    if ($('#loadingAnimation').get(0)) {
      this.texto = textHTML;
      this.titulo = title;
      this.imgTop = imagen;
      this.imgClass = imagenclass;
      this.animacion = animacion;

      if (this.animacion) {
        $('#loadingAnimation').html('');
        const animation = bodymovin.loadAnimation({
          container: document.getElementById('loadingAnimation'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: this.imgTop,
          crossOrigin: null
        });
      }
      $('#loading').modal({ backdrop: 'static', keyboard: false });
    }
  }

  animateRangeNumber(start:any, end:any, duration:any) {
    const range = end - start;
    this.current = start;
    const increment = end > start ? 2200 : -2200;
    const stepTime = Math.abs(Math.floor(duration / range));
    const obj = $('elementAnimateRangeNumber');
    const model = this;
    model.stopAnimateRangeNum = false;
    const timer = setInterval(function () {
      if (obj) {
        model.current += increment;
        if (model.current > end || model.stopAnimateRangeNum) {
          model.current = end;
          clearInterval(timer);
        }
      }
    }, stepTime);
  }
}